import React from 'react';

import { SelectedToolbarMenuCallout } from 'craft/components/SelectedToolbar';

interface Props {
  children: React.ReactNode;
  dom: HTMLElement | null;
  menuPosition: 'top' | 'bottom';
}

export const FloatingMenuTabContext = ({ children, dom, menuPosition }: Props) => {
  return (
    <SelectedToolbarMenuCallout
      dom={dom}
      calloutPlacement={menuPosition === 'top' ? 'bottom-start' : 'top-start'}
    >
      {children}
    </SelectedToolbarMenuCallout>
  );
};
